import { formatTlvDimensionText } from './art-kadishman-gallery.js';

// Reuse the gallery formatter without changing the saved product description.
function formatArtworkDescriptions(root = document) {
  root.querySelectorAll('product-info[data-url*="/products/tlv-artwork-"] .product__description').forEach(description => {
    if (!description.querySelector('a, img, video, iframe, table, h1, h2, h3, h4, h5, h6')) {
      const lines = description.innerText.split(/\n|·/).map(line => line.trim()).filter(Boolean);
      description.replaceChildren(...lines.map(line => {
        const paragraph = document.createElement('p');
        paragraph.textContent = line;
        return paragraph;
      }));
    }
    const walker = document.createTreeWalker(description, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) {
      const node = walker.currentNode;
      if (node.parentElement.closest('script, style')) continue;
      node.nodeValue = formatTlvDimensionText(node.nodeValue);
    }
  });
}
formatArtworkDescriptions();
document.addEventListener('shopify:section:load', event => formatArtworkDescriptions(event.target));
